// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__15wsQ","left":"InfoRow_left__wnU_U"};